// As strings dos vouchers de reembolso no esqueleto novo — o que os reembolsos dividem
// (`expense_voucher.ts`), o reembolso (`buildExpenseVoucherView`, #5034) e o de KM
// (`buildExpenseKmVoucherView`, #5035) —, em arquivo
// próprio pelo mesmo motivo do `hotel_voucher_catalog.ts`: o catálogo principal tem teto de 500
// linhas. O `CATALOG` espalha estas três por cima das dele.
const PT_BR = {
  'trips.expenseVoucher.status.review': 'Em análise',
  'trips.expenseVoucher.status.approved': 'Aprovado',
  'trips.expenseVoucher.status.refunded': 'Reembolsado',
  'trips.expenseVoucher.status.declined': 'Recusado',
  'trips.expenseVoucher.status.canceled': 'Cancelado',
  'trips.expenseVoucher.refundedOn': 'Reembolsado em {{date}}',
  'trips.expenseVoucher.payment': 'Pagamento',
  'trips.expenseVoucher.paymentType.PIX': 'Pix',
  'trips.expenseVoucher.paymentType.CREDIT_CARD': 'Cartão',
  'trips.expenseVoucher.paymentType.INVOICE': 'Faturado',
  'trips.expenseVoucher.title': 'Reembolso',
  'trips.expenseVoucher.dates': 'Despesa · {{date}}',
  'trips.expenseVoucher.wallet': 'Carteira utilizada',
  'trips.expenseVoucher.exchange': 'Taxa de câmbio',
  'trips.expenseVoucher.tax': 'Imposto',
  'trips.expenseVoucher.viewReceipt': 'Visualizar comprovante',
  'trips.expenseKmVoucher.title': 'Reembolso de KM',
  'trips.expenseKmVoucher.dates': 'Percurso · {{date}}',
  'trips.expenseKmVoucher.ownVehicle': 'Veículo próprio',
  'trips.expenseKmVoucher.ownVehicleInline': 'veículo próprio',
  'trips.expenseKmVoucher.route': 'Percurso de {{distance}}',
  'trips.expenseKmVoucher.calculation': 'Cálculo',
  'trips.expenseKmVoucher.distance': 'Distância',
  'trips.expenseKmVoucher.perKm': 'Valor por km',
  'trips.expenseKmVoucher.distanceChanged': 'Distância alterada de {{from}} km para {{to}} km.',
  'trips.expenseKmVoucher.manualChange.title': 'Alteração manual',
  'trips.expenseKmVoucher.manualChange.date': 'Data alterada',
  'trips.expenseKmVoucher.manualChange.origin': 'Endereço de origem alterado',
  'trips.expenseKmVoucher.manualChange.destination': 'Endereço final alterado',
  'trips.expenseKmVoucher.manualChange.fromTo': 'de {{from}} para {{to}}',
};

const EN: Record<keyof typeof PT_BR, string> = {
  'trips.expenseVoucher.status.review': 'Under review',
  'trips.expenseVoucher.status.approved': 'Approved',
  'trips.expenseVoucher.status.refunded': 'Refunded',
  'trips.expenseVoucher.status.declined': 'Declined',
  'trips.expenseVoucher.status.canceled': 'Cancelled',
  'trips.expenseVoucher.refundedOn': 'Refunded on {{date}}',
  'trips.expenseVoucher.payment': 'Payment',
  'trips.expenseVoucher.paymentType.PIX': 'Pix',
  'trips.expenseVoucher.paymentType.CREDIT_CARD': 'Card',
  'trips.expenseVoucher.paymentType.INVOICE': 'Invoiced',
  'trips.expenseVoucher.title': 'Refund',
  'trips.expenseVoucher.dates': 'Expense · {{date}}',
  'trips.expenseVoucher.wallet': 'Wallet used',
  'trips.expenseVoucher.exchange': 'Exchange rate',
  'trips.expenseVoucher.tax': 'Tax',
  'trips.expenseVoucher.viewReceipt': 'View receipt',
  'trips.expenseKmVoucher.title': 'Mileage refund',
  'trips.expenseKmVoucher.dates': 'Trip · {{date}}',
  'trips.expenseKmVoucher.ownVehicle': 'Own vehicle',
  'trips.expenseKmVoucher.ownVehicleInline': 'own vehicle',
  'trips.expenseKmVoucher.route': '{{distance}} trip',
  'trips.expenseKmVoucher.calculation': 'Calculation',
  'trips.expenseKmVoucher.distance': 'Distance',
  'trips.expenseKmVoucher.perKm': 'Rate per km',
  'trips.expenseKmVoucher.distanceChanged': 'Distance changed from {{from}} km to {{to}} km.',
  'trips.expenseKmVoucher.manualChange.title': 'Manual change',
  'trips.expenseKmVoucher.manualChange.date': 'Date changed',
  'trips.expenseKmVoucher.manualChange.origin': 'Origin address changed',
  'trips.expenseKmVoucher.manualChange.destination': 'Final address changed',
  'trips.expenseKmVoucher.manualChange.fromTo': 'from {{from}} to {{to}}',
};

const ES: Record<keyof typeof PT_BR, string> = {
  'trips.expenseVoucher.status.review': 'En análisis',
  'trips.expenseVoucher.status.approved': 'Aprobado',
  'trips.expenseVoucher.status.refunded': 'Reembolsado',
  'trips.expenseVoucher.status.declined': 'Rechazado',
  'trips.expenseVoucher.status.canceled': 'Cancelado',
  'trips.expenseVoucher.refundedOn': 'Reembolsado el {{date}}',
  'trips.expenseVoucher.payment': 'Pago',
  'trips.expenseVoucher.paymentType.PIX': 'Pix',
  'trips.expenseVoucher.paymentType.CREDIT_CARD': 'Tarjeta',
  'trips.expenseVoucher.paymentType.INVOICE': 'Facturado',
  'trips.expenseVoucher.title': 'Reembolso',
  'trips.expenseVoucher.dates': 'Gasto · {{date}}',
  'trips.expenseVoucher.wallet': 'Billetera utilizada',
  'trips.expenseVoucher.exchange': 'Tipo de cambio',
  'trips.expenseVoucher.tax': 'Impuesto',
  'trips.expenseVoucher.viewReceipt': 'Ver comprobante',
  'trips.expenseKmVoucher.title': 'Reembolso de KM',
  'trips.expenseKmVoucher.dates': 'Recorrido · {{date}}',
  'trips.expenseKmVoucher.ownVehicle': 'Vehículo propio',
  'trips.expenseKmVoucher.ownVehicleInline': 'vehículo propio',
  'trips.expenseKmVoucher.route': 'Recorrido de {{distance}}',
  'trips.expenseKmVoucher.calculation': 'Cálculo',
  'trips.expenseKmVoucher.distance': 'Distancia',
  'trips.expenseKmVoucher.perKm': 'Valor por km',
  'trips.expenseKmVoucher.distanceChanged': 'Distancia cambiada de {{from}} km a {{to}} km.',
  'trips.expenseKmVoucher.manualChange.title': 'Cambio manual',
  'trips.expenseKmVoucher.manualChange.date': 'Fecha cambiada',
  'trips.expenseKmVoucher.manualChange.origin': 'Dirección de origen cambiada',
  'trips.expenseKmVoucher.manualChange.destination': 'Dirección final cambiada',
  'trips.expenseKmVoucher.manualChange.fromTo': 'de {{from}} a {{to}}',
};

export const EXPENSE_VOUCHER_CATALOG = { 'pt-BR': PT_BR, en: EN, es: ES };
